import React, { Component } from 'react'
import {
  withStyles,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@material-ui/core'
import Done from '@material-ui/icons/Done'

const styles = theme => ({
  root: {
    padding: theme.spacing.unit
  },
  icon: {
    color: '#00e676',
    margin: 0
  },
  text: {
    padding: 0
  }
})

export class HourPickerItemBase extends Component {
  render() {
    const { classes, hour, selected, onClick } = this.props
    return (
      <ListItem
        button
        onClick={onClick}
        disabled={!hour.disponibile}
        className={classes.root}
      >
        <ListItemText className={classes.text}>{hour.descrizione}</ListItemText>
        {selected && (
          <ListItemIcon className={classes.icon}>
            <Done />
          </ListItemIcon>
        )}
      </ListItem>
    )
  }
}

export const HourPickerItem = withStyles(styles)(HourPickerItemBase)
